import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownPropTypes } from 'components/Dropdown';
import DatePicker from './DatePicker';

const DateControlsPicker = class extends Component {
  static propTypes = {
    date: PropTypes.instanceOf(Date),
    setDate: PropTypes.func,
    ...DropdownPropTypes,
  };

  handleSetDate = date => {
    const { setDate, closeMenu } = this.props;

    setDate(date);
    closeMenu();
  };

  render() {
    const { date, ...rest } = this.props;

    return (
      <DatePicker className="date-controls__date-picker" defaultValue={date} onChange={this.handleSetDate} {...rest} />
    );
  }
};

export default DateControlsPicker;
